import { render, staticRenderFns } from "./ReportHeader.vue?vue&type=template&id=2945dac0"
import script from "./ReportHeader.vue?vue&type=script&lang=ts"
export * from "./ReportHeader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports